import React from 'react';
import '../styles/Error.css';
import { useNavigate } from 'react-router-dom';

function ErrorDisplay() {
  const navigate = useNavigate();

  return (
    <div className="wholepage">
      <div className="errorContent">
        <h1 className="errorCode">404</h1>
        <p className="errorMessage">Oops! The page you're looking for doesn't exist.</p>
        <button className="homeButton" onClick={() => navigate('/')}>
          Go Home
        </button>
      </div>
    </div>
  );
}

export default ErrorDisplay;
